exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#long-text-tooltip-wrapper{display:flex;flex-direction:row;align-items:center;width:100%}#long-text-tooltip-wrapper .long-text-tooltip{max-width:100%;white-space:nowrap;display:inline-block;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
